import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "../components/ui/button";
import { Home } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";

const NotFoundPage = () => {
  const location = useLocation();
  const { t } = useLanguage();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  useEffect(() => {
    document.title = "Notfound";
  }, []);

  return (
    <div className="h-full flex items-center justify-center p-4">
      <div className="max-w-2xl w-full text-center space-y-8">
        {/* Hero Section */}
        <div className="space-y-6">
          <div className="relative">
            <div className="text-8xl font-bold bg-gradient-to-r from-green-primary to-green-secondary bg-clip-text text-transparent">
              404
            </div>
            <div className="absolute inset-0 bg-gradient-to-r from-green-primary to-green-light opacity-30 blur-3xl rounded-full"></div>
          </div>

          <div className="space-y-4">
            <h1 className="text-3xl font-bold text-foreground">
              {t("trangkhongtontai")}
            </h1>
            <p className="text-lg text-muted-foreground max-w-md mx-auto">
              {t("trangkhongtontaimota")}
            </p>
          </div>
        </div>

        <Button
          onClick={() => (window.location.href = "/")}
          className="h-12 bg-gradient-to-r from-medical-primary to-medical-primary/90 hover:from-medical-primary/90 hover:to-medical-primary text-white shadow-lg hover:shadow-xl transition-all duration-300"
        >
          <Home className="mr-2 h-5 w-5" />
          {t("vetrangchu")}
        </Button>
      </div>
    </div>
  );
};

export default NotFoundPage;
